export default "__VITE_ASSET__BKdewkzt__"